<div class="container action section">
  <div class="row">
    <div class="col-md-12">
      <h2 [innerText]="block.data.title"></h2>
      <p [innerHTML]="block.data.bodyCopy"></p>
    </div>
  </div>
  <div class="row d-flex flex-wrap action__section">
    <div *ngFor="let action of block.content" class="col-md-6">
      <div class="action__item-wrapper">
        <div class="action__item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
            <circle cx="17.75" cy="18.5" r="17.75" fill="url(#paint0_linear_148_172)"/>
            <path d="M25.6723 13.0847L14.6413 24.1158L9.62714 19.1017" stroke="white" stroke-width="2.00565"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <defs>
              <linearGradient id="paint0_linear_148_172" x1="17.75" y1="0.75" x2="17.75" y2="36.25"
                              gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF56AB" offset="0"/>
                <stop offset="1" stop-color="#FD2793"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div class="action__item-content">
          <h3 *ngIf="action.data.title" [innerHTML]="action.data.title"></h3>
          <div [innerHTML]="action.data.text"></div>
        </div>
      </div>
    </div>
  </div>
</div>
